import { use, useEffect, useRef, useState } from 'react';
import './pattern.css';
import { Pause, Play, SkipBack, SkipForward, Volume2, VolumeX } from 'react-feather';

import { motion } from "motion/react"
import {tonalitiesCorrespondances,notesCorrespondances,patternsCorrespondances,patternsList} from '../../exercises/patterns';
import Score from '../score/score';
import { child, get, getDatabase, push, ref,set } from 'firebase/database';
function Pattern({id,scale,user,app}) {

const tessitura = (id==25||id==23||id==19||id==7||id==4||id==13||id==16||id==29)?'low':(id==30||id==17||id==26||id==20||id==24||id==8||id==5||id==14)?'middle':'up';
const isDS = (id==25||id==26||id==23||id==24||id==19||id==20)?true:false;
  const [printIsPlaying, setPrintIsPlaying] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [printSpeed,setPrintSpeed] = useState(3);
  const [muted,setMuted] = useState(false);
  const draggable = useRef();
  const [progress,setProgress] = useState(0);
  const [printTonality,setPrintTonality] = useState(0);
  const [printNotes,setPrintNotes] = useState([]);
  const [printCurrentCycle,setPrintCurrentCycle] = useState(0);
  const [printFingers,setPrintFingers] = useState([]);
  const hasEnded = useRef(false);
  const [printCurrentPattern,setPrintCurrentPattern] = useState(0);
  const patterns = id==16?patternsList.eGD:id==17?patternsList.eDA:id==18?patternsList.eAE:id==25?patternsList.foGDA:id==26?patternsList.foDAE:id==23?patternsList.oGDA:id==24?patternsList.oDAE:id==19?patternsList.tGDA:id==20?patternsList.tDAE:id==13?patternsList.seGD:id==14?patternsList.seAD:id==15?patternsList.seAE:id==4?patternsList.sGD:id==5?patternsList.sAD:id==6?patternsList.sAE:id==7?patternsList.GD:id==8?patternsList.AD:patternsList.AE;
const isPlaying = useRef(false);
const total = useRef(84);
const speed = useRef(3);
const lastProgress = useRef(0);
const overallI = useRef(0);
const totalOverallI = useRef(0);
const totalTotal = useRef((id<=7||(id>=13&&id<=15)||id==25||id==26||id==19||id==20||id==23||id==24) ? 252:4068);
const currentPattern = useRef(0);
const currentCycle = useRef(0);
const i = useRef(0);
const t = useRef();
  const setTime = (e)=>{
    
    if(e.targetTouches){
      if(!e.targetTouches.length)
        return;
      e=e.targetTouches[0]
    }
    clearTimeout(t.current)
    const {x,width}=draggable.current.getBoundingClientRect();
    var r = e.clientX-x;
    if(r < 0)
      r =0;
    if(r > width)
      r=width;
    const aPercent = r/(width);
    const percent = r/(width+1);
  totalOverallI.current = Math.floor(percent*totalTotal.current);
  overallI.current = Math.floor(percent*total.current);
  i.current = Math.floor(totalOverallI.current%((id==25||id==26||id==23||id==24||id==19||id==20||id<=7||(id>=13&&id<=15)?(3):(6*16+18))/7));
  currentCycle.current = Math.floor(overallI.current/7);
  setPrintCurrentCycle(currentCycle.current)
  currentPattern.current = Math.floor(overallI.current % 7);
  
  lastProgress.current=percent;
  if(aPercent >= 1){
    isPlaying.current=false;
  setProgress(1);
  lastProgress.current=1;
  setPrintIsPlaying(false);
    i.current = patterns[currentPattern.current].length-1;
  }
    setProgress(percent);
    change('stop');
    if(aPercent>=1){
    hasEnded.current = true;
    }else{
      hasEnded.current = false;
    }
}
const change= (stop)=> {
if(hasEnded.current){
  return;
}
if(!patternsCorrespondances?.[tessitura]?.[currentCycle.current]?.[currentPattern.current]){
  isPlaying.current=false;
  setProgress(1);
  setPrintIsPlaying(false);

    hasEnded.current = true;
  return;
}
const tonality = patternsCorrespondances?.[tessitura]?.[currentCycle.current][currentPattern.current];
setPrintTonality(tonality)
const notesArray = [];
for (let strings = 1; strings < 5; strings++) {
  for (let notes = 1; notes < 14; notes++) { 
    
    notesArray.push({
      s:strings,
      n:notes,
      text:tonalitiesCorrespondances?.[tonality]?.[notesCorrespondances?.[notes-1+currentCycle.current]?.[5-strings-1]]?.replace('s','♯').replace('f','♭')||''
    })
  }
}
setPrintNotes(notesArray);
const fingersArray = [];
    patterns?.[currentPattern.current]?.[i.current]?.map(e=>{
      fingersArray.push({
        class:e
      })
      
    })
    setPrintFingers(fingersArray);
setPrintCurrentPattern(currentPattern.current)
if(stop){
  if(!isPlaying.current)
  return;
clearTimeout(t.current);
  t.current= setTimeout(change,speed.current*1000)
  return;
}

  i.current = i.current+1;
  if(patterns[currentPattern.current].length == i.current){
    i.current=0;
  overallI.current = overallI.current+1;
    currentPattern.current = currentPattern.current+1;
  }
  
  if(patterns.length == currentPattern.current){
    i.current=0;
    currentPattern.current=0;
    currentCycle.current = currentCycle.current+1;

  setPrintCurrentCycle(currentCycle.current)
  }
  setProgress(totalOverallI.current/totalTotal.current);
  lastProgress.current = totalOverallI.current/totalTotal.current;
  totalOverallI.current = totalOverallI.current+1;

  if(!isPlaying.current)
  return;

clearTimeout(t.current);
  t.current= setTimeout(change,speed.current*1000)
}



  useEffect(()=>{
    change();
  },[])
  
  useEffect(()=>{
    if(printIsPlaying){
      if(!app)
        return;
      let uid = user.uid;
      get(ref(getDatabase(app), `users/${uid}`)).then((snapshot) => {
  if (snapshot.exists()) {
    const us = snapshot.val();
    if(new Date().getTime()-us.lastActivity <= 172800000){
set(ref(getDatabase(app),'users/'+uid+'/lastActivity'),new Date().getTime()).then(ok => 1).catch(console.error);
    }
    else{
    set(ref(getDatabase(app),'users/'+uid),{
        lastActivity:new Date().getTime(),
        streakBegin:new Date().getTime(),
        firstName:user.displayName.split(' &|& ')[0],
        lastName:user.displayName.split(' &|& ')[1]
      }).then(ok => 1).catch(console.error);
    }

  } else {
    set(ref(getDatabase(app),'users/'+uid),{
        lastActivity:new Date().getTime(),
        streakBegin:new Date().getTime(),
        firstName:user.displayName.split(' &|& ')[0],
        lastName:user.displayName.split(' &|& ')[1]
      }).then(ok => 1).catch(console.error);
  }
}).catch((error) => {
  console.error(error);
});

      
      
    }
  },[printIsPlaying]);

  const controls = (e)=>{
    if(e.keyCode==39){
      next();
    }
    if(e.keyCode==37){
prev();
    }
    if(e.keyCode==32){
      if(isPlaying.current == false){
        play();
      } else{
        pause();
      }
    }
  }
  useEffect(()=>{
document.addEventListener('keyup',controls)
    return ()=>{
      document.removeEventListener('keyup',controls);
    }
  },[])

  useEffect(()=>{
document.addEventListener('mouseup',mouseUp)
document.addEventListener('mousemove',mouseMove)
document.addEventListener('touchmove',mouseMove)
    return ()=>{
      document.removeEventListener('mousemove',mouseMove);
      document.removeEventListener('touchmove',mouseMove);
      document.removeEventListener('mouseup',mouseUp);
    }
  },[isSetting])
  const mouseMove=(e)=>{
  if(!isSetting){
    return false;
  }

  setTime(e);
}
  const mouseUp=(e)=>{
  if(isSetting)
  setTime(e);
  setIsSetting(false)
}
const mouseDown=(e)=>{

  setTime(e);
  setIsSetting(true);

}

const pause = ()=>{
  isPlaying.current = false;
  setPrintIsPlaying(false)
  clearTimeout(t.current);
}
const play = ()=>{
  if(hasEnded.current)
    return;
  setPrintIsPlaying(true)
  isPlaying.current = true;
  clearTimeout(t.current)
  t.current = setTimeout(change,speed.current*1000)
}
const next = ()=>{

  i.current = i.current+1;
  if(patterns[currentPattern.current].length == i.current && (patterns[currentPattern.current+1]||patterns.length == currentPattern.current+1)){
    i.current=0;
  overallI.current = overallI.current+1;
    currentPattern.current = currentPattern.current+1;
  }
  if(patterns.length == currentPattern.current){
    i.current=0;
    currentPattern.current=0;
    currentCycle.current = currentCycle.current+1;

  setPrintCurrentCycle(currentCycle.current)
  }
  setProgress(totalOverallI.current/totalTotal.current);
  totalOverallI.current = totalOverallI.current+1;
if(patterns[currentPattern.current].length == i.current && !patterns[currentPattern.current+1]){
 
  hasEnded.current = true;
  i.current = i.current-1;
  totalOverallI.current = totalOverallI.current-1;
}
  lastProgress.current = totalOverallI.current/totalTotal.current;
  if(!patternsCorrespondances?.[tessitura]?.[currentCycle.current]?.[currentPattern.current]){

  return;
}
  change('stop');
  clearTimeout(t.current)
  if(isPlaying.current){
    t.current = setTimeout(change,speed.current*1000)
  }
}
const prev = ()=>{

   hasEnded.current = false;
  if(totalOverallI.current == 0)
    return;
  i.current = i.current-1;
  if(i.current < 0){
    i.current=patterns[currentPattern.current-1]?.length - 1;
  overallI.current = overallI.current-1;
    currentPattern.current = currentPattern.current-1;
  }
  
  if(currentPattern.current < 0){
   
    currentPattern.current=patterns.length - 1;
    currentCycle.current = currentCycle.current-1;
     i.current=patterns[currentPattern.current].length - 1;

  setPrintCurrentCycle(currentCycle.current)
  }
  setProgress(totalOverallI.current/totalTotal.current);
  totalOverallI.current = totalOverallI.current-1;
 
  lastProgress.current = totalOverallI.current/totalTotal.current;
  change('stop');
  clearTimeout(t.current)
  if(isPlaying.current){
    t.current = setTimeout(change,speed.current*1000)
  }
}
const handlePause = ()=>{
if(printIsPlaying)
  pause();
else
play();

          }
  return (
    <div className='patternContainer'>
      <div className='patterns'>
       
        <div className="tablature">

  <div className="pattern">{printCurrentPattern+1}</div> <div className={printTonality.toString().match('s')?'tonality sharp':printTonality.toString().match('f')?'tonality flat':'tonality'}>{printTonality.toString().replace('s','').replace('f','')}</div>
    <div className="strings">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div className="notesLabels">
      {printNotes.map(n=>
        <div key={'n'+n.n+' s'+n.s} className={'n'+n.n+' s'+n.s}>{n.text}</div>
      )}
    </div>
    <div className="notes">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div className="fingers">
{printFingers.map(c=><div key={c.class} className={c.class}></div>)}

    </div>
  </div>
      </div>
      <div className='score'>
<motion.div className='scoreDrag' drag='x'
onDragEnd={(e,i)=>{
  if(i.offset.x < -50){
    next();
  }
  if(i.offset.x > 50){
    prev();
  }
}}
dragConstraints={{ left: 0,right:0 }}
dragElastic={{left:.4,right:.4}}>
<Score isDS={isDS} scale={scale} speed={printSpeed} isPlaying={printIsPlaying} muted={muted}
currentCycle={printCurrentCycle}
      fingers={printFingers}
      notes={printNotes}
      tonality={printTonality}
    />
    </motion.div>
<div className='scoreControls'>
  <div onClick={prev}>
<SkipBack/>
  </div>
  <div onClick={next}>
    <SkipForward/>
  </div>
</div>
      </div>
      <div className='controls'>
        <div className='controlsPause' onClick={handlePause}>
          {printIsPlaying?<Pause/>:<Play/>}
        </div>
        <motion.div onTouchEnd={mouseUp} ref={draggable} onTouchStart={mouseDown} onMouseDown={mouseDown} className='controlsTrack'>
          <div className='controlsProgress' style={{width:progress*100+'%'}}></div>
        </motion.div>
        <div className='controlsSpeed' onClick={()=>{
          const getSpeed = (s=>{
            if(s==3)
              return 5;
            if(s==10)
              return 1;
            if(s==5)
              return 10;
            if(s==1)
              return 2;
            if(s==2)
              return 3;
          })
          speed.current = getSpeed(speed.current);
          setPrintSpeed(s=>getSpeed(s))
        }}>
          {printSpeed}s
        </div>
        <div className='controlsSound' onClick={()=>setMuted(p=>!p)}>
          {muted?<VolumeX/>:<Volume2/>}
        </div>
      </div>
    </div>

  );
}

export default Pattern;